import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import {
  createFilterStructure,
  ProductsReportsFilterKeys,
  ProductsReportsListFilterOpts
} from "../../components/ProductsReportsListPage/filters";
import { ProductReport_productReport_edges_node } from "../../types/ProductReport";
import ProductsReportsList from "../ProductsReportsList";

interface ProductsReportsListPageProp
  extends ListProps,
    FilterPageProps<ProductsReportsFilterKeys, ProductsReportsListFilterOpts>,
    TabPageProps {
  products: ProductReport_productReport_edges_node[];
  onBack: () => void;
  download: () => void;
}

const ProductsReportsListPage: React.FC<ProductsReportsListPageProp> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  products,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Product Performance Report">
          <Button
            color="primary"
            variant="contained"
            disabled={!products}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Product"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <ProductsReportsList products={products} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default ProductsReportsListPage;
